/** Add local filtering to the rendered page; native article links work without JS. */
(() => {
  const initialize = (root = document) => {
    for (const finder of root.querySelectorAll('[data-journal-finder]')) {
      if (finder.dataset.initialized) continue;
      const input = finder.querySelector('input[type="search"]');
      const filters = finder.querySelector('.dv-journal__filters');
      const status = finder.querySelector('.dv-journal__finder-status');
      if (!input || !filters || !status) continue;
      finder.dataset.initialized = 'true';
      const articles = [...finder.querySelectorAll('.dv-journal__article-results li')];
      filters.hidden = false;
      status.hidden = false;
      const update = () => {
        const query = input.value.trim().toLocaleLowerCase();
        const topic = filters.querySelector('input:checked')?.value || 'All';
        let count = 0;
        for (const article of articles) {
          const matches = (!query || article.textContent.toLocaleLowerCase().includes(query))
            && (topic === 'All' || topic === article.dataset.category);
          article.hidden = !matches;
          if (matches) count += 1;
        }
        const message = count === 0 ? status.dataset.empty
          : count === 1 ? status.dataset.singular : status.dataset.plural;
        status.textContent = message.replace('__count__', String(count));
      };
      input.addEventListener('input', update);
      filters.addEventListener('change', update);
      update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
